'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function () {
            $.spinner().start();
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    stoneFactModal: function () {
        var desktopVisible = false;
        var modalVisible = false;

        // Track modal visibility on user interaction
        $('#stoneFactsModal').on('show.bs.modal', function () {
            modalVisible = true;
        }).on('hide.bs.modal', function () {
            modalVisible = false;
        });

        /**
         * Handles the stone facts modal visibility based on window width.
         *
         * - If window width is < 1024px or in portrait mode, the modal is shown and the desktop version is hidden.
         * - If window width is ≥ 1024px and < 1250px, the modal is hidden and the desktop version is shown.
         * - If window width is ≥ 1250px, the modal is hidden and the desktop version is hidden.
         */
        function handleResize() {
            var windowWidth = $(window).width();
            var isPortrait = window.matchMedia('(orientation: portrait)').matches;

            if (windowWidth < 1024 || isPortrait) {
                if (desktopVisible) {
                    $('.stone-fact-desktop').removeClass('set-position').addClass('d-none');
                    desktopVisible = false;

                    if (!modalVisible) {
                        $('#stoneFactsModal').modal('show');
                    }
                }
            } else if (windowWidth >= 1024 && windowWidth < 1250) {
                if (modalVisible) {
                    $('#stoneFactsModal').modal('hide');
                    modalVisible = false;

                    $('.stone-fact-desktop').addClass('set-position').removeClass('d-none');
                    desktopVisible = true;
                }
            } else {
                $('#stoneFactsModal').modal('hide');
                $('.stone-fact-desktop').removeClass('set-position').addClass('d-none');
                desktopVisible = false;
            }
        }

        // Initial load
        handleResize();

        // Resize / orientationchange
        $(window).on('resize orientationchange', handleResize);

        // Click toggle
        $('.stone-facts-trigger').off('click').on('click', function () {
            var windowWidth = $(window).width();
            var isPortrait = window.matchMedia('(orientation: portrait)').matches;

            if (windowWidth < 1024 || isPortrait) {
                if (!modalVisible) {
                    $('#stoneFactsModal').modal('show');
                } else {
                    $('#stoneFactsModal').modal('hide');
                }
            } else if (windowWidth >= 1024 && windowWidth < 1250) {
                desktopVisible = !desktopVisible;
                $('.stone-fact-desktop').toggleClass('set-position', desktopVisible).toggleClass('d-none', !desktopVisible);
            }
        });

        $(document).on('click', function (e) {
            var windowWidth = $(window).width();
            var isPortrait = window.matchMedia('(orientation: portrait)').matches;

            if (windowWidth >= 1024 && windowWidth < 1250 && !isPortrait) {
                var $target = $(e.target);

                if (
                    !$target.closest('.stone-fact-desktop').length && !$target.closest('.stone-facts-trigger').length
                ) {
                    $('.stone-fact-desktop').removeClass('set-position').addClass('d-none');
                    desktopVisible = false;
                }
            }
        });

        let pageIsScrolling = false; // Flag used to prevent .stone-fact-desktop appear on scrolling

        if ($(window).width() >= 1250 && !window.matchMedia('(orientation: portrait)').matches) {
            $('.media-img, .stone-fact-desktop').on('mouseover', function () {
                if (!pageIsScrolling) {
                    $('.stone-fact-desktop').addClass('set-position').removeClass('d-none');
                }
            });
            $('.media-img, .stone-fact-desktop').on('mouseleave', function () {
                $('.stone-fact-desktop').removeClass('set-position').addClass('d-none');
            });
        }

        $('#pair-it-up-cta').on('click', function () {
            pageIsScrolling = true;
            $('.stone-fact-desktop').addClass('d-none');

            var headerHeight = $('header').outerHeight();
            var targetOffset = $('#pair-it-up-section').offset().top - headerHeight;

            $('html').animate({
                scrollTop: targetOffset
            }, 600, function () {
                pageIsScrolling = false;
            });
            window.disableZoomDeskProductImage();
        });
    }
};

var modal = $('#collapseOne');
var shouldScroll = false; // flag to scroll upto product specs section

modal.off('shown.bs.modal.scrollToSpec').on('shown.bs.modal.scrollToSpec', function () {
    if (!shouldScroll) return;
    shouldScroll = false;

    var $container = modal.find('.scroll-bar');
    var $target = modal.find('#product-specs');

    if ($container.length && $target.length) {
        var desired = $target.position().top + $container.scrollTop();
        $container.animate({ scrollTop: desired }, 600);
    }
});

$('#price-details, .price-details').on('click', function () {
    if ($(window).outerWidth() < 1024) {
        shouldScroll = true;
        modal.modal('show');
    } else {
        $('#collapseOne').collapse('show');
        var headerHeight = $('header').outerHeight();
        var targetOffset = $('#product-specs').offset().top - headerHeight;

        $('html').animate({
            scrollTop: targetOffset
        }, 600);
    }
});

// Scroll to FAQ section
$('.pdp-enquire-section .ckc-faq-btn').on('click', function () {
    var $gotQuestions = $('#collapseThree');
    if ($(window).outerWidth() < 1024) {
        $gotQuestions.modal('show');
    } else {
        $('#collapseThree').collapse('show');
        var headerHeight = $('header').outerHeight();
        var targetOffset = $('#headingThree').offset().top - headerHeight;

        $('html').animate({
            scrollTop: targetOffset
        }, 600);
    }
});

var $alreadyInCartMsg = $('.product-restriction-message');
if ($alreadyInCartMsg.length > 0) {
    var msg = $alreadyInCartMsg.val();
    toastMessageHelper.showNotification(msg, '', 'Basket-icon');
}

// Toggle add-to-bag and go-to-cart-btn based on in-productlist
$(document).ready(function () {
    if ($('.in-productlist').val() === 'true') {
        $('.product-details-right .add-to-bag').addClass('d-none');
        $('.product-details-right .go-to-cart-btn').removeClass('d-none');
    }
});
